import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getJob } from '../db/index.js';

/** Stays visible while the inspector works through every screen for a site. */
export function JobIdentity() {
  const { jobId } = useParams();
  const [job, setJob] = useState<Awaited<ReturnType<typeof getJob>>>();
  useEffect(() => {
    let cancelled = false;
    setJob(undefined);
    if (jobId)
      void getJob(jobId).then((next) => {
        if (!cancelled) setJob(next);
      });
    return () => {
      cancelled = true;
    };
  }, [jobId]);
  if (!jobId) return null;
  const current = job?.jobId === jobId ? job : undefined;
  return (
    <aside className="job-identity" aria-label="Current inspection site">
      <strong>{[jobId, current?.comboPartnerJobId].filter(Boolean).join(' / ')}</strong>
      <span>{current?.siteAddress || 'Site address unavailable'}</span>
    </aside>
  );
}
